import { CrudApiService } from '../utilities/crud.api.service';
import { ICrudApiService } from '../utilities/types';

class OrionIqAnalyticsApiService implements ICrudApiService<any> {
  crudApiService = new CrudApiService({ modelDefinition: undefined });

  urls = {
    capture: '/orioniq-be/orion-iq-analytics/capture',
    accountIdentify: '/orioniq-be/orion-iq-analytics/identify-account',
    userIdentify: '/orioniq-be/orion-iq-analytics/identify-user',
  };

  capture = (featureName: unknown, eventName: unknown, eventProps: Record<string, unknown>) =>
    this.crudApiService.do(this.urls.capture, {
      payload: { featureName, eventName, eventProps },
      meta: { dontShowProgressBar: true },
    });

  identifyAccount = (accountProps: Record<string, unknown>) =>
    this.crudApiService.do(this.urls.accountIdentify, {
      payload: { accountProps },
      meta: { dontShowProgressBar: true },
    });

  identifyUser = (userProps: Record<string, unknown>) =>
    this.crudApiService.do(this.urls.userIdentify, { payload: { userProps }, meta: { dontShowProgressBar: true } });
}

export const orionIqAnalyticsApiService = new OrionIqAnalyticsApiService();
